import { tv } from "@fanka/tailwind-variants";

export const SEARCH_FLOAT_AREA_CLASS_NAME = tv({
  base: "shadow-mid bg-grayScale-0 absolute mt-[8px] flex max-h-[286px] w-full flex-col overflow-y-scroll rounded z-popover",
});
